var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { withTheme } from 'styled-components';
import { isNil, isEmpty } from 'ramda';
import InputContainer from '../InputContainer';
import Label from '../Label';

var InputSelect = function InputSelect(props) {
  var _defaultThemeSelectCo;

  var label = props.label,
      options = props.options,
      isSearchable = props.isSearchable,
      isDisabled = props.isDisabled,
      placeholder = props.placeholder,
      onChange = props.onChange,
      onSelect = props.onSelect,
      value = props.value,
      rest = _objectWithoutProperties(props, ['label', 'options', 'isSearchable', 'isDisabled', 'placeholder', 'onChange', 'onSelect', 'value']);

  var hasLabel = !isNil(label) && !isEmpty(label);
  var selectPlaceholder = placeholder || 'Please select';
  var values = value ? [].concat(value) : null;
  var localValue = void 0;

  if (values !== null) {
    localValue = options.filter(function (o) {
      return values.indexOf(o.value + '') !== -1;
    });
  }

  var _useState = useState(false),
      changed = _useState[0],
      hasChanged = _useState[1];

  var smallThemeSelectControl = {
    fontSize: '16px',
    borderWidth: '1px',
    '&:hover': {
      borderColor: props.theme.colours.primary.base
    },
    '&:focus': {
      borderColor: props.theme.colours.primary.base
    },
    minHeight: '0px'
  };
  var defaultThemeSelectControl = (_defaultThemeSelectCo = {
    borderRadius: props.theme.radius,
    cursor: 'pointer',
    marginTop: '0px',
    borderWidth: '1px',
    boxShadow: 'none'
  }, _defaultThemeSelectCo['marginTop'] = '4px', _defaultThemeSelectCo.marginBottom = '4px', _defaultThemeSelectCo.paddingTop = '1px', _defaultThemeSelectCo.paddingLeft = '6px', _defaultThemeSelectCo.fontFamily = '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif', _defaultThemeSelectCo.paddingBottom = '1px', _defaultThemeSelectCo.minHeight = '48px', _defaultThemeSelectCo.position = 'relative', _defaultThemeSelectCo.transition = 'all 0.25s ease-in-out', _defaultThemeSelectCo.border = '1px solid #D1D6DA', _defaultThemeSelectCo['boxShadow'] = 'none', _defaultThemeSelectCo);
  var defaultThemeSelectOption = {
    borderBottom: '1px solid #ddd',
    fontFamily: props.theme.font_body,
    cursor: 'pointer',
    paddingLeft: 18,
    paddingTop: 12,
    paddingBottom: 12
  };
  var smallThemeSelectOption = {
    fontSize: '16px',
    paddingLeft: 6,
    paddingTop: 6,
    paddingBottom: 6
  };
  var themeSelectControl = props.size === 'small' ? smallThemeSelectControl : defaultThemeSelectControl;
  var themeSelectOption = props.size === 'small' ? smallThemeSelectOption : defaultThemeSelectOption;
  var customStyles = {
    container: function container(provided, _) {
      return _extends({}, provided, {
        marginTop: 0,
        padding: 0,
        '&.changed > div': {
          borderColor: props.theme.colours.primary.base
        }
      });
    },
    menuList: function menuList(provided, _) {
      return _extends({}, provided, {
        margin: 0,
        padding: 0
      });
    },
    dropdownIndicator: function dropdownIndicator(provided, state) {
      return _extends({}, provided, {
        color: state.isFocused ? props.theme.colours.primary.base : '#ccc'
      });
    },
    option: function option(provided, state) {
      return _extends({}, provided, themeSelectOption, {
        color: state.isFocused ? '#fff' : props.theme.colours.primary.base,
        backgroundColor: state.isFocused ? props.theme.colours.primary.base : '#fff'
      });
    },
    control: function control(provided, state) {
      return _extends({}, provided, themeSelectControl, {
        borderColor: state.isFocused ? props.theme.colours.primary.base : '#D1D6DA',
        border: '1px solid #D1D6DA'
      });
    },
    singleValue: function singleValue(provided, state) {
      var opacity = state.isDisabled ? 0.5 : 1;
      var transition = 'opacity 300ms';
      return _extends({}, provided, {
        opacity: opacity,
        transition: transition
      });
    }
  };

  if (props.size === 'small') {
    customStyles = {
      control: function control(base) {
        return _extends({}, base, {
          minHeight: 30,
          borderWidth: '1px'
        });
      },
      dropdownIndicator: function dropdownIndicator(base) {
        return _extends({}, base, {
          padding: 4
        });
      },
      clearIndicator: function clearIndicator(base) {
        return _extends({}, base, {
          padding: 4
        });
      },
      multiValue: function multiValue(base) {
        return _extends({}, base, {
          backgroundColor: variables.colorPrimaryLighter
        });
      },
      menu: function menu(base) {
        return _extends({}, base, {
          textAlign: 'left'
        });
      },
      valueContainer: function valueContainer(base) {
        return _extends({}, base, {
          padding: '0px 6px'
        });
      },
      input: function input(base) {
        return _extends({}, base, {
          margin: 0,
          padding: 0
        });
      }
    };
  }

  var handleChange = function handleChange(option, evt) {
    hasChanged(true);

    if (onSelect) {
      onSelect(option.value);
    }

    if (onChange) {
      onChange(option, evt);
    }
  };

  return React.createElement(InputContainer, {
    display: props.display,
    width: props.width,
    maxWidth: props.maxWidth,
    minheight: props.minheight
  }, hasLabel && React.createElement(Label, null, label), React.createElement(Select, _extends({
    isDisabled: isDisabled,
    placeholder: selectPlaceholder,
    className: 'input-select ' + (changed ? 'changed' : 'unchanged'),
    options: options,
    theme: function theme(_theme) {
      return _extends({}, _theme, {
        colors: _extends({}, _theme.colors, {
          primary25: props.theme.colours.primary.base,
          primary: props.theme.colours.primary.base
        })
      });
    },
    styles: customStyles,
    isSearchable: isSearchable,
    onChange: handleChange,
    value: localValue
  }, rest)));
};

export default withTheme(InputSelect);